import { t } from "@lingui/macro";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import { ClubStackNavigatorParamList } from "@/navigators/ClubNavigator";
import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import {
  UpdateDiningBookingInput,
  useUpdateDiningBookingMutation,
} from "./__generated__/useUpdateDiningBookingMutation.graphql";

export const useUpdateDiningBooking = () => {
  const { showToast } = useToast();
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();
  const [commitUpdateDiningBooking, isUpdating] =
    useMutation<useUpdateDiningBookingMutation>(
      useUpdateDiningBookingMutationString
    );

  const updateDiningBooking = (input: UpdateDiningBookingInput) => {
    commitUpdateDiningBooking({
      variables: { input },
      onCompleted: (response) => {
        if (!response.updateDiningBooking?.success) {
          return;
        }

        if (navigation.canGoBack()) {
          navigation.goBack();
        } else {
          navigation.navigate("Home", { screen: "MainHome" });
        }

        showToast({
          description: t`Booking Updated.`,
          semanticStyle: "success",
          toastId: "update-dining-booking-success",
        });
      },
      onError: () => {
        showToast({
          description: t`Sorry. An error occurred while updating your booking.`,
          semanticStyle: "error",
          toastId: "update-dining-booking-error",
        });
      },
    });
  };

  return [updateDiningBooking, isUpdating] as const;
};

const useUpdateDiningBookingMutationString = graphql`
  mutation useUpdateDiningBookingMutation($input: UpdateDiningBookingInput!) {
    updateDiningBooking(input: $input) {
      success
      errors {
        code
        message
        field
      }
      booking {
        ...DiningBookingSummary_booking
      }
    }
  }
`;
